import { NgModule } from '@angular/core';
import { CartRemoveEntrySuccessEvent } from '@spartacus/cart/base/root';
import { CheckoutEvent } from '@spartacus/checkout/base/root';
import { provideConfig } from "@spartacus/core";
import { OrderPlacedEvent } from '@spartacus/order/root';
import { NavigationEvent, SearchPageResultsEvent, ProductDetailsPageEvent } from '@spartacus/storefront';
import { BaseTmsModule, TmsConfig } from "@spartacus/tracking/tms/core";
import { GtmModule } from "@spartacus/tracking/tms/gtm";
import { GonvarriTrackingCollectorService } from 'src/app/core/GTM/gonvarri-tracking-collector.service';
import { GonvarriCartEventModule } from './custom-events/cart/gonvarri-cart-event.module';
import { GonvarriCartAddEntrySuccessEvent, GonvarriCartRemoveEntrySuccessEvent } from './custom-events/cart/gonvarri-cart.events';
import { GonvarriProductDetailsPageEvent, GonvarriSearchPageResultsEvent } from './custom-events/product/gonvarri-product-page.events';
import { GonvarriProductPageEventModule } from './custom-events/product/gonvarri-product-page-event.module';
import { GonvarriQuickStockNavigationEvent } from './custom-events/navigation/gonvarri-navigation.events';
import { GonvarriNavigationEventModule } from './custom-events/navigation/gonvarri-navigation-event.module';
import { GonvarriCheckoutNavigationEventModule } from './custom-events/checkout/navigation/gonvarri-checkout-navigation-event.module';
import { GonvarriNavigateToCheckoutEvent, GonvarriQuoteNavigateToCheckoutEvent } from './custom-events/checkout/navigation/gonvarri-checkout-navigation.events';
import { GonvarriPlacedOrderEvent } from './custom-events/checkout/placed-order/gonvarri-placed-order.events';
import { GonvarriPlacedOrderEventModule } from './custom-events/checkout/placed-order/gonvarri-placed-order-event.module';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [],
  imports: [
    BaseTmsModule.forRoot(),
    GtmModule,
    GonvarriCartEventModule,
    GonvarriProductPageEventModule,
    GonvarriNavigationEventModule,
    GonvarriCheckoutNavigationEventModule,
    GonvarriPlacedOrderEventModule,
  ],
  providers: [provideConfig(<TmsConfig>{
    tagManager: {
      gtm: {
        gtmId: environment.gtmId,
        debug: !environment.production,
        collector: GonvarriTrackingCollectorService,
        events: [
          NavigationEvent,
          GonvarriSearchPageResultsEvent,
          GonvarriProductDetailsPageEvent,
          GonvarriQuickStockNavigationEvent,
          GonvarriCartAddEntrySuccessEvent,
          GonvarriCartRemoveEntrySuccessEvent,
          GonvarriQuoteNavigateToCheckoutEvent,
          GonvarriNavigateToCheckoutEvent,
          GonvarriPlacedOrderEvent,
        ],
      },
    },
  })]
})
export class TagManagementFeatureModule { }
